import React from 'react';
import LottieIconComponent from '../lottie/LottieIconComponent';
import { LOTTIE_ICONS } from '../lottie/lottie-icons';

const useWeatherAnimation = (estado, size) => {
    if (!estado) {
        return null;
    }

    if (estado.startsWith('11')) {
        return <LottieIconComponent icon={LOTTIE_ICONS.SUNNY} width={size} height={size} />;
    }

    if (
        estado.startsWith('12') ||
        estado.startsWith('15') ||
        estado.startsWith('14') ||
        estado.startsWith('17')
    ) {
        return <LottieIconComponent icon={LOTTIE_ICONS.CLOUDS} width={size} height={size} />;
    }

    if (estado.startsWith('13')) {
        return <LottieIconComponent icon={LOTTIE_ICONS.SUN_CLOUDS} width={size} height={size} />;
    }

    if (
        estado.startsWith('23') ||
        estado.startsWith('25') ||
        estado.startsWith('26') ||
        estado.startsWith('43') ||
        estado.startsWith('44') ||
        estado.startsWith('45') ||
        estado.startsWith('46')
    ) {
        return <LottieIconComponent icon={LOTTIE_ICONS.RAIN} width={size} height={size} />;
    }

    if (estado.startsWith('81')) {
        return <LottieIconComponent icon={LOTTIE_ICONS.MIST} width={size} height={size} />;
    }

    return <LottieIconComponent icon={LOTTIE_ICONS.INFO} width={size * 0.6} height={size * 0.6} />;
};

export default useWeatherAnimation;
